import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";

interface Props {
    filters: FiltersTypes;
}

export const OrgCloseStageFilterLabel: React.FC<Props> = ({ filters }) => {
    const closeStages = useSortedCloseStages();
    const { closeStageIds } = filters;

    const selectedStageNames = useMemo(
        () =>
            closeStages
                .filter((s) => closeStageIds?.includes(s.id))
                .map((s) => s.name),
        [closeStages, closeStageIds],
    );

    if (selectedStageNames.length === 0) {
        return null;
    }

    if (selectedStageNames.length === 1) {
        return <span>{selectedStageNames[0]}</span>;
    }

    return <span>{selectedStageNames.length} stage filters</span>;
};
